<template>
    <div>
        <div class="popup__header popup__header--center">
            <span class="title title--sm popup__title">{{ $lang('auth.password.reset.title') }}</span>
        </div>
        <div class="popup__content">
            <errors :errors="errors"></errors>
            <form class="form" @submit.prevent="reset">
                <label class="form__item">
                    <span class="form__label form__label--hidden">{{ $lang('auth.password.reset.label') }}</span>
                    <el-input class="input input--big" placeholder="email@info.com" v-model="form.email" required readonly></el-input>
                </label>
                <label class="form__item">
                    <span class="form__label form__label--hidden">{{ $lang('auth.password.reset.label2') }}</span>
                    <el-input class="input input--big" type="password" :placeholder="$lang('auth.password.reset.label2.placeholder')" v-model="form.password" required></el-input>
                </label>
                <label class="form__item">
                    <span class="form__label form__label--hidden">{{ $lang('auth.password.reset.label3') }}</span>
                    <el-input class="input input--big" type="password" :placeholder="$lang('auth.password.reset.label3.placeholder')" v-model="form.password_confirmation" required></el-input>
                </label>
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg btn--w100">{{ $lang('auth.password.reset.button') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    import Errors from "../../error/errors";

    export default {
        name: "Reset",
        components: {Errors},
        data: () => ({
            form: {
                email: '',
                password: '',
                password_confirmation: '',
                token: ''
            },
            errors: null
        }),
        mounted() {
            let uriParams = new URLSearchParams(window.location.search);

            this.form.token = uriParams.get("token");
            this.form.email = uriParams.get("email");
        },
        methods: {
            ...mapActions('auth', [
                'resetPassword',
            ]),
            reset(){
                this.resetPassword(this.form)
                    .then((response) => {
                        window.location.href = "/";
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    });

            }
        }
    }
</script>
